import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.scss'
import App from '../src/pages/base/App'
// import reportWebVitals from './reportWebVitals'
import configureStore from './redux/middleware/configureStore'

const root = ReactDOM.createRoot(document.getElementById('root'))
import * as atatus from 'atatus-spa'
atatus.config('70b61dadfcda476cbbd451a990de91cf').install()

const user = window.location.toString().split('/')[3]
const domain = window.location.toString()

if(!user && domain.includes('breeze')){
	window.location.pathname = '/pci'
}
root.render(
	// <React.StrictMode>
		<Provider store={configureStore()}>
			<App />
		</Provider>
	// </React.StrictMode>
)
// reportWebVitals()
